import { preactMarkup } from 'common/helper/preact/markup';
import { GoBackViewFactory } from 'common/module/go-back/view.factory';
import { HeaderView } from 'common/module/header/view';
import { HeaderSavedPropertiesViewFactory } from 'common/module/header-saved-properties/view.factory';

export function HeaderViewFactory(): HeaderView {
  return new HeaderView(GoBackViewFactory(), HeaderSavedPropertiesViewFactory(), preactMarkup, {});
}
